/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-05-30 16:14:42
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\user\activationemail\locales\zh-CN.ts
 */
export default {
  'page.activationemail.txtone': '邮箱发送成功',
  'page.activationemail.txtstart': '请在',
  'page.activationemail.txttime': '60分钟',
  'page.activationemail.txtend': '内前往邮箱进行激活',
  'page.activationemail.btnback': '返回',
  'page.activationemail.gotoemail': '请前往邮箱进行激活',
};
